import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import {
    ROLES,
    CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import SettingsWrapper from '../SettingsWrapper.vue';
import CannedAudioHome from './Index.vue';

export default {
    routes: [
        {
            path: frontendURL('accounts/:accountId/settings/canned-audio'),
            component: SettingsWrapper,
            children: [
                {
                    path: '',
                    redirect: to => {
                        return { name: 'canned_audio_list', params: to.params };
                    },
                },
                {
                    path: 'list',
                    name: 'canned_audio_list',
                    meta: {
                        featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
                        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
                    },
                    component: CannedAudioHome,
                },
            ],
        },
    ],
};
